import { createHooksActions, createHooksSelectors } from 'src/helpers/redux'
import * as store from 'src/store/modules/notifications'

export { store }

export * from 'src/store/modules/notifications/state'

export const useNotificationsSelect = createHooksSelectors<
  typeof store.selectors.selectors
>(store.selectors.selectors)

export const useNotificationsAction = createHooksActions<typeof store.actions>(
  store.actions,
  store.selectors.communications
)
